var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXwhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.631375 0.429688C0.471671 0.429688 0.304665 0.483403 0.18278 0.60519C-0.0609267 0.84939 -0.0609267 1.25909 0.18278 1.50329L4.10287 5.4261L0.18278 9.34891C-0.0609267 9.59311 -0.0609267 10.0028 0.18278 10.247C0.426549 10.4906 0.836201 10.4906 1.07997 10.247L5 6.32421L8.92003 10.247C9.1638 10.4906 9.57345 10.4906 9.81722 10.247C10.0609 10.0028 10.0609 9.59311 9.81722 9.34891L5.89713 5.4261L9.81722 1.50329C10.0609 1.25909 10.0609 0.84939 9.81722 0.60519C9.69534 0.483403 9.52827 0.429688 9.36862 0.429688C9.20892 0.429688 9.04198 0.483403 8.92003 0.60519L5 4.52799L1.07997 0.60519C0.958086 0.483403 0.79108 0.429688 0.631375 0.429688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXwhite);
export default __webpack_public_path__ + "static/media/xwhite.65ae2f4d4714ead5111495f2219a85bb.svg";
export { ForwardRef as ReactComponent };